document.addEventListener('click', (event) => {
    if (event.target.closest('.tabs-nav li')) {
        const tab = event.target.closest('.tabs-nav li');
        const tabsNav = document.querySelectorAll('.tabs-nav li');
        const tabPanes = document.querySelectorAll('.tab-pane');

        tabsNav.forEach(item => item.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('active'));

        tab.classList.add('active');
        document.getElementById(tab.dataset.tab).classList.add('active');
      
        if(document.getElementById(tab.dataset.tab).id == 'reviews' ) {
          if (window.okeWidgetApi) {
              window.okeWidgetApi.initAllWidgets()
          }
        }
    }
});


jQuery(document).ready(function(){
  jQuery('.media_carousel').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10%'
  });

  jQuery('#gym_carousel').slick({
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    responsive: [
    {
      breakpoint: 1365,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1
      }
    }
    ]
  });
});
  